module.exports = __webpack_public_path__ + "static/media/blog_grid_2.20bcc309.jpg";